/**
 * Narrow controller-owned media values to browser-renderable image URLs. Keeping this rule in the
 * report domain gives table cells and chart axis previews one identical allow-list without making
 * the shared media primitives understand report rows.
 */
export function resolveReportImageUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const candidate = value.trim()
  if (candidate.length <= 4) return null

  try {
    const url = new URL(candidate)
    return url.protocol === 'https:' || url.protocol === 'http:' ? candidate : null
  } catch {
    return null
  }
}
